import script from "./AdminFormElementNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementNumber.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementNumber.vue?vue&type=style&index=0&id=51ea789b&lang=scss"

const __exports__ = script;

export default __exports__